import { StanButton, StanModal } from '@/components';
import { useStanRouter } from '@/hooks/useStanRouter';

interface NoLinksiteModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const NoLinksiteModal = ({ isOpen, onClose }: NoLinksiteModalProps) => {
    const { push } = useStanRouter();

    const handleGoToMyStore = () => {
        onClose();
        push('/stores');
    };

    return (
        <StanModal id='no-linksite-modal' isOpen={isOpen} onClose={onClose} title='Set up your store first' size='sm'>
            <div className='flex flex-col gap-4'>
                <p className='text-body-md text-gray text-center'>
                    You need at least one product in your store before you can create a funnel. Head over to{' '}
                    <strong className='text-dark'>My Store</strong> to add your first product.
                </p>
                <div className='flex w-full gap-2 pt-2 max-sm:flex-col'>
                    <StanButton name='cancel-no-linksite' variant='outline' onClick={onClose} className='w-full'>
                        Cancel
                    </StanButton>
                    <StanButton name='go-to-my-store' onClick={handleGoToMyStore} className='w-full'>
                        Go to My Store
                    </StanButton>
                </div>
            </div>
        </StanModal>
    );
};
